import { render, staticRenderFns } from "./tabDBCopy.vue?vue&type=template&id=59c9ee52&"
import script from "./tabDBCopy.vue?vue&type=script&lang=js&"
export * from "./tabDBCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports